<bari-modal>
  <div modal-body>
    <bari-animation animation="card_check"></bari-animation>
    <p class="welcome">Aviso viagem ativado com sucesso</p>
    <p>Seu aviso será desativado automaticamente daqui 45 dias, mas caso prefira, você poderá fazer isso manualmente a
      qualquer momento.</p>
  </div>
  <footer>
    <bari-button
      size="big"
      color="dark"
      text="between"
      icon="arrow-right"
      iconColor="#fff"
      (click)="close()"
    >
      Ok, ver meus cartões
    </bari-button>
  </footer>
</bari-modal>
